<div class="modal-header px-4">
  <h4 class="modal-title header-5">
    {{ configs.title }}
  </h4>
   <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        "
      />
    </button>
</div>
@if(isLoading){
<div class="loading-div w-100 d-flex justify-content-center align-items-center" *ngIf="isLoading">
  <app-loading [text]="'Loading...'"></app-loading>
</div>
} @else{
<div class="modal-body my-2">
  <div class="row">
    <div class="col-md-12">
      <div *ngFor="let item of configs?.fields">
        <div class="d-flex py-2">
          <div class="col-2 header-8">{{ item.name }}</div>
          @if(item.key === 'rciScore'){
          <div class="col-10">
            <app-star-ranker [rank]="configs?.data?.[item.key]"
              [isError]="configs?.data?.[item.key] <= 2"></app-star-ranker>
          </div>
          }@else{
          <div class="col-10 header-coverage">
            <div
              *ngIf="shouldRenderMarkdown(configs?.data?.[item.key], item.key); else structuredContent"
              class="markdown-content"
              [innerHTML]="configs?.data?.[item.key] | markdown"
            ></div>
            <ng-template #structuredContent>
              <ng-container *ngIf="isStringList(configs?.data?.[item.key]); else plainText">
                <ol>
                  <li *ngFor="let listItem of splitStringList(configs?.data?.[item.key])">
                    {{ listItem }}
                  </li>
                </ol>
              </ng-container>
              <ng-template #plainText>
                {{ configs?.data?.[item.key] | stripHtml }}
              </ng-template>
            </ng-template>
          </div>

          }
        </div>
      </div>

      <div class="mt-4 rci-rep">
        <mat-expansion-panel class="mb-4" *ngFor="let panel of configs.expandItems; let i = index"
          >
          <mat-expansion-panel-header [ngStyle]="panel.headerStyle">
            <mat-panel-title [ngStyle]="panel.titleStyle" class="panel-header">
              {{ panel.title ? panel.title : "" }}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div>
            <app-zorro-table tableId="rci-qual-rep" class="w-100" [columns]="panel.columns" [data]="panel.rows"></app-zorro-table>
          </div>
        </mat-expansion-panel>
      </div>
    </div>
  </div>
</div>
}